import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { ConnectedIcon } from 'images'
import ErrorFallback from 'components/Shared/ErrorFallback'
import SetupMFA from 'components/Cognito/MFA/Setup/SetupMFA'
import { useCognito } from 'components/Cognito/CognitoContextProvider'
import { mfaTypes } from 'components/Cognito/types'

export default function SetupMFASetting() {
  const { t } = useTranslation()
  const {
    user: { mfaSettings },
  } = useCognito()
  const { activate_mfa = [] } = mfaSettings || {}
  const hasSetupAuthenticator = activate_mfa.some((x) => x === mfaTypes.softwareTokenMfa)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="setup-mfa-setting settings-page__sectionBody">
        <div className="settings-page__sectionColumn w-100">
          <div className="settings-page__sectionWrapper">
            <div className="settings-page__sectionState flex-wrap">
              <h3 className="settings-page__sectionTitle">{t('Settings.system.mfa.title')}</h3>
              <div className="d-flex align-items-center gap-3">
                <p className="settings-page__sectionValue d-inline-block">
                  {t('Settings.system.mfa.description')}
                  {hasSetupAuthenticator && (
                    <span className="card-settings-account__value__verified pl-2">
                      <ConnectedIcon width={10} height={10} />
                      {t('common.verified')}
                    </span>
                  )}
                </p>
              </div>
            </div>
            <SetupMFA
              removeEnabled
              emailEnabled={false}
              authBtnText={t('Settings.system.mfa.button')}
            />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}
